import { type LinkAcquiringType } from '../../openApi';

export const OrderAcquiringTypes: Record<LinkAcquiringType, LinkAcquiringType> = {
    YandexPay: 'YandexPay',
    CloudPay: 'CloudPay',
};
